import axios from 'axios';
import { TopConfig } from '../context/ConfigContext';
import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';
import { ClaimFormPayload } from '../types/claim-form-payload';

export const submitForm = async (formConfig: FormConfig, topConfig: TopConfig, claimData: ClaimFormPayload) => {
    const { submitApiPath } = formConfig;

    const dscmNumber = window.topContext.config.getSiteConfig().dscmNumber;

    const requestConfig = topConfig.services.submit;

    const request = {
        ...requestConfig,
        url: requestConfig.url + submitApiPath,
        headers: {
            ...requestConfig.headers,
            'x-top-dscm': dscmNumber
        },
        data: claimData
    };

    try {
        await axios(request);
    } catch (e) {
        console.error('Could not submit:');
        console.error(' - Error: ', e);
        console.error(' - Payload: ' + JSON.stringify(request, null, 4));
        throw new Error(`Submit service failed: ${JSON.stringify(e)} - Payload: ${JSON.stringify(request, null, 4)}`);
    }
};
